// extracted by mini-css-extract-plugin
module.exports = {"alert-type":"AlertType-module__alert-type__1IaCU"};